/* eslint-disable jsdoc/require-jsdoc */

import React from 'react';
import type { ReactNode } from 'react';

type TaskItemsDone = boolean | undefined;

type TaskItemsStateContext = [TaskItemsDone, React.Dispatch<TaskItemsFormatReducerAction>];

const defaultValue = [undefined, () => {}] as TaskItemsStateContext;

const TaskItemsFormatContext = React.createContext<TaskItemsStateContext>(defaultValue);

type TaskItemsFormatReducerAction = boolean | undefined;

const reducer = (_state: TaskItemsDone, action: TaskItemsFormatReducerAction) => {
	return action;
};

export function TaskItemsFormatProvider({ children }: { children: ReactNode }): React.JSX.Element {
	const value = React.useReducer(reducer, undefined);

	return (
		<TaskItemsFormatContext.Provider value={value}>{children}</TaskItemsFormatContext.Provider>
	);
}

export function useTaskItemsFormatContext(): TaskItemsStateContext {
	return React.useContext(TaskItemsFormatContext);
}

export function TaskItemsFormatConsumer({
	children,
}: {
	children: ([isChecked, dispatch]: TaskItemsStateContext) => ReactNode;
}): React.JSX.Element {
	return <TaskItemsFormatContext.Consumer>{children}</TaskItemsFormatContext.Consumer>;
}
